import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";


export default function CommunityRoyalty() {
  const { formatDateTime } = useContext(OnmaxContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const username = localStorage.getItem("username");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [pages, setPages] = useState(1);


  const getData = async () => {
    if (!username) {
      return;
    }
    setisLoading(true);

    await axios.post(process.env.REACT_APP_BACKEND_LINK, {
      method: "rank",
      submethod: "getbyid",
      username: username,
      key: process.env.REACT_APP_KEY,
      page: currentPage,
      pageSize: pageSize
    })
      .then((res) => {
        console.log("res rank inc", res.data);
        // var dedata = decryptData(res.data);
        setisLoading(false);

        if (res.data.error) {
          return "";
        }

        setdata(res.data.data);
        setPages(Math.ceil(res.data.dataLength / pageSize));

      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getData();
  }, [username, pageSize, currentPage]);

const customStyles = `
    .bg-soft-primary { 
      background-color: rgba(13, 110, 253, 0.1) !important; 
      color: #0d6efd !important; 
    }
    
    .bg-soft-success { 
      background-color: rgba(34, 197, 94, 0.1) !important; 
      color: #22c55e !important; 
    }
    
    .card-dashboard {
      border: 1px solid #334155;
      background: #1e293b; 
    }
    
    .table-dashboard thead th {
      background-color: #0f172a;
      color: #94a3b8;
      font-weight: 600;
      letter-spacing: 0.5px;
      border-bottom: 1px solid #334155;
    }
    
    .table-dashboard tbody td {
      color: #f8fafc;
      border-bottom: 1px solid #334155;
    }
    
    .table-dashboard tbody tr:hover td {
      background-color: #334155; 
      color: #fff;
    }
    
    .text-slate-400 { 
      color: #94a3b8 !important; 
    }
    
    .text-white-custom { 
      color: #f8fafc !important; 
    }
    
    .text-xs { 
      font-size: 11px; 
    }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">

                {/* Card Container */}
                <div className="db-profile-card mb-5">

                  {/* Card Header */}
                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Rank Reward</div>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '700px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3" style={{ width: '10%' }}>Sr.</th>
                            <th scope="col" className="py-3" style={{ width: '30%' }}>Rank</th>
                            <th scope="col" className="py-3" style={{ width: '30%' }}>Reward</th>
                            <th scope="col" className="pe-4 py-3 text-end" style={{ width: '30%' }}>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="4" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td colSpan="4" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No data found</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((ele, i) => {
                              const index = currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">{index}</span>
                                  </td>

                                  <td>
                                    <span className="badge bg-soft-primary fs-6 fw-normal">{ele.rank_title}</span>
                                  </td>

                                  <td>
                                    <span className="fw-bold text-success fs-6">${ele.income}</span>
                                  </td>

                                  <td className="pe-4 text-end">
                                    {ele.date ? (
                                      <span className="text-slate-400 small">{formatDateTime(ele.date)}</span>
                                    ) : '-'}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Card Footer for Pagination */}
                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
